import React from "react";
import Main from "./main";
import Modal from "_c/Modals";

const PremiumModal = (props) => {
  return (
    <Modal onClose={props.onClose} isOpen={props.isOpen}>
      <Main {...props} />
    </Modal>
  );
};

export default PremiumModal;
